import React, { useEffect } from "react";
import { Checkbox, Message } from "semantic-ui-react";
import { toast } from "react-toastify";
import { HeaderPage } from "../../components/Admin";
import { useAuth, useSiteConfig } from "../../hooks";

// Configuración → Módulos opcionales (solo Súper Usuario): lo que cada
// instalación usa o no. Apagado, el módulo sale del menú; los datos no se
// borran. El backend también lo exige (siteconfig/api/views.py: estos campos
// no están en BUSINESS_FIELDS). Las propinas tienen su propia página.
const MODULES = [
  {
    field: "show_extras",
    label: "Adicionales",
    hint: "Carta → Adicionales (extras que se suman a un plato).",
  },
  {
    field: "show_offers",
    label: "Ofertas",
    hint: "Carta → Ofertas (combos y promociones).",
  },
];

export function ModulesAdmin() {
  const { auth } = useAuth();
  const { siteConfig, getSiteConfig, updateSiteConfig } = useSiteConfig();

  useEffect(() => {
    getSiteConfig();
  }, []);

  if (!auth?.me?.is_superuser) {
    return <Message warning>No tienes permiso para cambiar los módulos.</Message>;
  }

  const onToggle = async (field, checked) => {
    try {
      await updateSiteConfig({ [field]: checked });
    } catch (error) {
      toast.error(error.message);
    }
  };

  return (
    <div>
      <HeaderPage title="Módulos opcionales" />
      <p style={{ color: "#777" }}>
        Si el restaurante no usa un módulo, apágalo y se quita del menú. Los datos no se borran:
        al encenderlo vuelve tal cual.
      </p>
      {MODULES.map((module) => (
        <div key={module.field} style={{ marginBottom: 16 }}>
          <Checkbox
            toggle
            label={module.label}
            disabled={!siteConfig}
            checked={siteConfig?.[module.field] !== false}
            onChange={(_, data) => onToggle(module.field, data.checked)}
          />
          <p style={{ color: "#777", margin: "4px 0 0" }}>{module.hint}</p>
        </div>
      ))}
    </div>
  );
}
